<template>
    <div class="App_box" :class="{'App_box_electron':isElectronNonWxWork(),'isH5Open':isH5Open}">
      <div class="App_nav_box" v-if="showNavSet.flag" :style="{'width':showNavSet.width + 'px',}">
          <portalNav :navList="navList" :moreList="moreList" v-model="actNav" @changeVal="changeVal" @initVal="initVal" :unreadNumObj="unreadNumObj" :sessionMap="sessionMap"></portalNav>
      </div>
      <div class="App_content_box">
            <div class="App_content_navBox" style="-webkit-app-region: drag" v-if="isElectronNonWxWork()">
                <div class="App_content_navBtnBox">
                    <div class="App_content_nav_min" @click="toSendWindowFunc('window-minSize')"></div>
                    <div class="App_content_nav_resize" @click="toSendWindowFunc('window-maxSize')"></div>
                    <i class="iconfont icon-quxiao" @click="toSendWindowFunc('window-hide')"></i>
                </div>
            </div>
            <div class="App_content_portal" v-if="!componentObj[actNav]">
                <router-view v-slot="{ Component }">
                    <component :is="Component" :showNavFlag="showNavSet.flag" :hideHeader="hideHeader" />
                </router-view>
            </div>
      </div>
      <lowVer v-model:dlgVs="lowVerDlgVs"></lowVer>
      <uploadDailog ref="uploadDailog"></uploadDailog>
      <webIm v-if="outLink && isOpenIm" :sence="showNavSet.flag ? 'PAGE':'IM'" :defaultNav="actNav" @getTalkUnreadNum="getTalkUnreadNum" @selectOpTalk="selectOpTalk"> </webIm>

    </div>
  </template>
  
  <script>
  import uploadDailog from '../common/upload/uploadDailog.vue'
  import portalNav from './portalNav.vue';
  import webIm from 'qs3_pc_im/src/webIm.vue';
  import webImPopup from 'qs3_pc_im/src/webImPopup.vue';
  export default {
    name: 'app',
    components: {
      portalNav,
      webIm,
      uploadDailog,
      webImPopup,
    },
    data(){
      return {
          interval:null,
          observer:null,
          resText:'',
          lowVerDlgVs:false,
          hasSet:false,
          outLink:false,
          isOpenIm:false,
          showNavSet:{
              flag:false,
              width:80,
          },
          componentObj:{
              'talkPortal':'webIm',
              'contact':'webIm',
          },
          navList:[],
          navAllList:[
              {name:'消息',iconAct:require('@img/portal/navIcon/xx_act.png'),icon:require('@img/portal/navIcon/xx.png'),key:'talkPortal',path:'/talkPortal'},
              {name:'通讯录',iconAct:require('@img/portal/navIcon/txl_act.png'),icon:require('@img/portal/navIcon/txl.png'),key:'contact',path:'/contact'},
              {name:'日历',iconAct:require('@img/portal/navIcon/rili_act.png'),icon:require('@img/portal/navIcon/rili.png'),key:'rl',path:'/scheduleCenterPortal'},
              {name:'待办',iconAct:require('@img/portal/navIcon/txl_act.png'),icon:require('@img/portal/navIcon/txl.png'),key:'pExam',path:'/flow/workbentch/pExam'},
              {name:'知识宝',iconAct:require('@img/portal/navIcon/zsb_act.png'),icon:require('@img/portal/navIcon/zsb.png'),key:'zsb',needOpenKey:'KNOW',path:'/knowBase/kbHome'},
              {name:'邮箱',iconAct:require('@img/portal/navIcon/yx_act.png'),icon:require('@img/portal/navIcon/yx.png'),key:'yx',path:'/emailPortal/emailReceive'},
              {name:'任务',iconAct:require('@img/portal/navIcon/rw_act.png'),icon:require('@img/portal/navIcon/rw.png'),key:'rw',path:'/myResponsibility'},
              {name:'工作台',iconAct:require('@img/portal/navIcon/gzt_act.png'),icon:require('@img/portal/navIcon/gzt.png'),key:'gzt',path:'/'},
              {name:'自建应用',iconAct:require('@img/portal/menu_white.png'),icon:require('@img/portal/menu_white.png'),key:'zjyy',path:'/selfBuildApp'},
              {name:'社区',iconAct:require('@img/portal/option3.png'),icon:require('@img/portal/option3op.png'),key:'sq',path:'/communityPortal'},
              {name:'智搭',iconAct:require('@img/portal/ai.png'),icon:require('@img/portal/ai.png'),key:'ai',path:'/AIPartner/AIPartnerFw',needOpenKey:'AI'},
              {name:'云学堂',iconAct:require('@img/portal/navIcon/yxt_act.png'),icon:require('@img/portal/navIcon/yxt.png'),key:'yxt',needOpenKey:'EDUCATION',path:'/examStu/myTrain'},
              {name:'流程通',iconAct:require('@img/portal/navIcon/lct_act.png'),icon:require('@img/portal/navIcon/lct.png'),key:'lct',needOpenKey:'BPA',path:'/bizFlow/myWorks/myFlowList'},
          ],
          moreList:[],
          moreAllList:[
              {
                  img: require('@img/portal/option5.png'),
                  path: '/openPlat/appKey',
                  name: '开放平台',
                  needOpenKey:'OPENPLAT',
                  key:'appKey',
                  needAdmin:true,
                  needOrgAdmin:true,
                  needFlagShip:false,
                  'background': 'linear-gradient(322.35deg, #F7A300 6.16%, #FAD200 94.62%)',
                  'boxShadow': '0px 3px 20px 3px rgba(255, 183, 17, 0.2)'
              },
              {
                  img: require('@img/portal/option6.png'),
                  path:'/orgmgt/index',
                  name: '管理后台',
                  needAdmin:true,
                  key:'orgmgt',
                  needOrgAdmin:true,
                  needFlagShip:false,
                  'background': 'linear-gradient(322.35deg, #3370FF 6.16%, #45C7FF 94.62%)',
                  'boxShadow': '0px 3px 20px 3px rgba(55, 130, 255, 0.2)'
              },
              {
                img: require('@img/portal/option4.png'),
                path:'/selfBuildApp/selfBuildAppMgt',
                  name: '自建应用',
                  needAdmin:true,
                  key:'orgmgt',
                  needOrgAdmin:true,
                  needFlagShip:false,
                'background': 'linear-gradient(322.35deg, #31C485 6.16%, #4AD9B4 94.62%)',
                'boxShadow': '0px 3px 20px 3px rgba(49, 197, 134, 0.2)'
              },
              {
                  img: require('@img/portal/option7.png'),
                  path:'/sysmgt/smsMgt',
                  name: '系统管理',
                  needAdmin:true,
                  needSys:true,
                  key:'smsMgt',
                  needFlagShip:false,
                  'background': 'linear-gradient(322.35deg, #00B6D2 6.16%, #39CAFF 94.62%)',
                  'boxShadow': '0px 3px 20px 3px rgba(11, 186, 219, 0.2)'
              },
          ],
          unreadNumObj:{},
          actNav:'',
          gztUrl:'',
          lastUrlObj:{},
          hideHeader:false,
          sessionMap:{},
          firstTips:true,
          isH5Open:false,
      } 
    },
      created(){
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            this.isH5Open = true
        }
        this.$http.post(this.$api.pub.isLogin, {
        }).then(resLogin=>{
            this.outLink =  resLogin.payload
            if(resLogin.payload){
                this.queryHolidayByCond();
            this.showNavSet.flag = this.isElectronNonWxWork();  
            if(this.isElectronNonWxWork()){
                const { ipcRenderer } = require('electron')
                ipcRenderer.send('checkForUpdatesAndNotify')
                ipcRenderer.on('update_available', () => {
                    this.$message({
                        message: '发现新版本，后台自动下载中……',
                        type: 'success'
                    });
                })
                ipcRenderer.on('update_downloaded', () => {
                    this.$confirm(`新版本已下载，是否重启并更新`, '版本更新', {
                        confirmButtonText: '重启并更新',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(() => {
                        ipcRenderer.send('restart_app')
                    })
                })
                ipcRenderer.on('update-not-available', () => {
                    if(!this.firstTips){
                        this.$message({
                            message: '已经是最新版本了',
                            type: 'success'
                        });
                    }
                    else{
                        this.firstTips = false
                    }
                })
            }
            this.getIsOpen()
            this.$http.post(this.$api.org.user.queryMySysTheme, {
            }).then(res=>{
                    if(res.code=='SUCCESS'){
                    document.body.classList.add( ( res.payload || 'skyBlue'))
                    }else{
                    document.body.classList.add('skyBlue')
                    }
            }).catch(()=>{
                    document.body.classList.add('skyBlue')
            })
            }else{
            document.body.classList.add('skyBlue')
            this.showNavSet.flag = false
            }
        }).catch(()=>{
            document.body.classList.add('skyBlue')
            this.$router.push('/pub/pswdLogin?newLink=open')
        })
      },
      watch: {
          '$route.fullPath': {
              handler(newVal) {
                  if(newVal){
                      let exceptList = ['/pub/','/pubForm']
                      let bool = false
                      for(let item of exceptList){
                          if(this.$route.fullPath.includes(item)){  
                              bool = true
                              this.hasSet = false
                          }
                      }
                      this.outLink = !bool
                      if(bool){
                        this.actNav = 'gzt'
                          if(this.interval){
                              clearInterval(this.interval)
                          }
                          this.resText = ''
                          let hasWater = document.getElementById('qs_waterMarkDom')
                          if(hasWater){
                              document.body.removeChild(hasWater)
                          }
                          this.showNavSet.flag = false
                      }
                      else{
                          let hasWater = document.getElementById('qs_waterMarkDom')       
                          if(!hasWater){
                              this.initWaterMark()
                          }
                      }
                      this.checkCurPathFunc()
                  }
              },
              deep: true,
              immediate: false
          },
      },
      beforeUnmount(){
          if(this.interval){
              clearInterval(this.interval)
          }
      },
      mounted() {
          this.$uploadOp.setRefDom(this.$refs['uploadDailog'])
          if(this.isElectronNonWxWork()){
            const { webFrame } = require('electron');
            webFrame.setZoomFactor(0.9);
          }
      },
      methods:{
        checkCurPathFunc(){
            if(!this.showNavSet.flag){
                return
            }
            this.queryPendingNum()
            this.queryTaskCount()
            let obj = {
                'KNOW':'zsb',
                'BPA':'lct',
                'examStu':'yxt',
                'examMGT':'yxt',
                'shequ':'sq',
                'TASK':'rw',
                'schedule':'rl',
                'FLOW':'pExam',
                'AI':'ai',
                'EMAIL':'yx',
                'zjyy':'zjyy',
                'grzx':'grzx',
                'smsMgt':'smsMgt',
                'orgmgt':'orgmgt',
                'openPlat':'openPlat',
            }
            if(this.$route.meta){
                let pathObj = {
                    '/talkPortal':'talkPortal',
                    '/contact':'contact',
                }
                if(pathObj[this.$route.fullPath]){
                    this.actNav = pathObj[this.$route.fullPath]
                    this.hideHeader = false
                }
                else if(obj[this.$route.meta.type]){
                    this.actNav = obj[this.$route.meta.type]
                    this.hideHeader = true
                }
                else{
                    this.actNav = 'gzt'
                    this.gztUrl = this.$route.fullPath
                    this.hideHeader = false
                }
            }
            else{
                this.actNav = 'gzt'
                this.gztUrl = this.$route.fullPath
                this.hideHeader = false
            }
            this.lastUrlObj[this.actNav] = this.$route.fullPath
        },
        changeVal(item){
            let path = item.path
            if(item.key == 'gzt'){
                path = this.gztUrl || '/'
            }
            if(this.lastUrlObj[item.key]){
                path = this.lastUrlObj[item.key]
            }
            this.$router.push(path)
        },
        initVal(){
            let curNavItem = this.navAllList.find((item)=>{
                return item.key == this.actNav;
            })
            let path = curNavItem.path
            if(this.actNav == 'gzt'){
                path =  '/'
            }
            if(this.lastUrlObj[this.actNav]){
                this.lastUrlObj[this.actNav] = path
            }
            this.$router.push(path)
        },
          initWaterMark(){
              let that = this
              if(this.resText){
                  toBuildMark()
              }
              else{
                  this.$http.post(this.$api.pub.isLogin, {
                  }).then(resLogin=>{
                      if(resLogin.payload){
                        this.showNavSet.flag = this.isElectronNonWxWork();
                        this.getIsOpen()
                          if(!this.hasSet){
                              this.$http.post(this.$api.worktbl.querySessionMap,{}).then(res=>{
                                  this.hasSet = true
                                  if(res.payload.org_waterMark){
                                      let bool = JSON.parse(res.payload.org_waterMark).isOpen
                                      if(bool){
                                          this.resText = res.payload.emp_name + ' ' +(res.payload.emp_no || '')
                                          toBuildMark()
                                      }
                                  }
                                  if(res.payload.org_imSet){
                                      this.isOpenIm = JSON.parse(res.payload.org_imSet).isOpen
                                  }
                                  else{
                                      this.isOpenIm = false
                                  }
                                  this.$authOp.setCurVersion(res.payload.ov_verCode,this)
                              })
                          }
                      }
                      else{
                        this.showNavSet.flag = false
                        this.hasSet = false
                      }
                  })
              }
              function toBuildMark(){
                  that.buildWaterMark()
                  that.interval = setInterval(()=>{
                      let hasWater = document.getElementById('qs_waterMarkDom')
                      if(!hasWater){
                          that.buildWaterMark()
                      }
                      else{
                          document.body.removeChild(hasWater)
                          that.buildWaterMark()
                      }
                  },3000)
              }
          },
          buildWaterMark(){
              let waterDom = document.createElement('div')
              waterDom.setAttribute('class','qs_waterMarkDom_box')
              waterDom.setAttribute('id','qs_waterMarkDom')
              for(let i = 0;i<72;i++){
                  let textDom = document.createElement('div')
                  textDom.setAttribute('class','qs_waterMarkDom_item')
                  let spanDom = document.createElement('span')
                  spanDom.setAttribute('data-markText',this.resText)
                  textDom.appendChild(spanDom)
                  waterDom.appendChild(textDom)
              }
              document.body.appendChild(waterDom)
          },
          getTalkUnreadNum(num){
              this.unreadNumObj['talkPortal'] = num
          },
        isElectronNonWxWork() {
            const ua = navigator.userAgent.toLowerCase();
            return ua.includes('electron/') && !ua.includes('wxwork');
            // return true
        },
          queryPendingNum() {
              this.$http.post(this.$api.bpm.workbentch.myPendding.queryPendingNum,{}).then(res => {
                  let sumFlowNum = 0
                  if(res.payload){
                      for(let key in res.payload){
                          sumFlowNum += Number(res.payload[key])
                      }
                  }
                  this.unreadNumObj['pExam'] = sumFlowNum
              })
          },
          queryTaskCount() {
              this.$http.post(this.$api.taskCenter.queryTaskCount, {}).then(res => {
                  this.unreadNumObj['rw'] = res.payload.allCount
              })
          },
        getIsOpen(){
            let token = this.sessionMap['token']
            let curToken = JSON.parse(localStorage.getItem('QUESHU3_SESSION') || '{}').token
            if(this.showNavSet.flag && (!token || !curToken || (token != curToken))){
                this.$http.post(this.$api.worktbl.querySessionMap,{}).then(res=>{
                this.sessionMap = res.payload
                this.$http.post(this.$api.org.orgAuth.isOpenProduct, {
                    
                }).then((res)=>{
                    let prdtOpen = res.payload || {}
                    this.navList = this.navAllList.filter((item)=>{
                        return !item.needOpenKey || prdtOpen[item.needOpenKey] || this.sessionMap.sys_isAdmin
                    })
                    this.moreList = this.moreAllList.filter((item)=>{
                        return  ((item.needSys && this.sessionMap.sys_isAdmin) || (!item.needSys)) && 
                        ((item.needOrgAdmin && this.sessionMap.org_isAdmin || !item.needOrgAdmin)) &&
                        (!item.needOpenKey || prdtOpen[item.needOpenKey] || this.sessionMap.sys_isAdmin || this.sessionMap.org_isAdmin) 
                    })
                })
            })
            }
        },
        selectOpTalk(){
            if(this.isElectronNonWxWork()){
                let imItem = this.navAllList.find((item)=>{return item.key == 'talkPortal'})
                this.changeVal(imItem)
            }
        },
        toSendWindowFunc(func){
            if(this.isElectronNonWxWork()){
                const { ipcRenderer } = require('electron')
                ipcRenderer.send(func)
            }
        },
        queryHolidayByCond(){
            let curYear = new Date().getFullYear()
            let curStr = curYear + '-01-01'
            let nextStr = (curYear + 2) + '-01-01'
             this.$http.post(this.$api.holidayMgt.queryHolidayByCond,{
                ohd_act:'1',
                startDate:curStr,
                endDate:nextStr,
            }).then(res=>{
                localStorage.setItem('holidayList',JSON.stringify(res.payload||[]))
            })
        }
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .App_box{
      width:100%;
      height:100%;
      display: flex;
      .App_nav_box{
          flex: 0 0 auto;
          transition: all 0.25s;
      }
      .App_content_box{
          flex-grow: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          .App_content_navBox{
            height: var(--topNavHeight);
            width: 100%;
            background: var(--mainColor);
            display: flex;
            align-items: center;
            flex: 0 0 auto;
            justify-content: flex-end;
            .App_content_navBtnBox{
                display: flex;
                align-items: center;
                gap: 16px;
                padding-right: 16px;
                -webkit-app-region: no-drag;
                .App_content_nav_min{
                    cursor: pointer;
                    width: 14px;
                    height: 14px;
                    display: flex;
                    align-items: center;
                    &::before{
                        content: '';
                        width: 100%;
                        height: 1px;
                        background-color: #fff;
                    }
                }
                .App_content_nav_resize{
                    width: 12px;
                    height: 12px;
                    border: 1px solid #fff;
                    cursor: pointer;
                    box-sizing: border-box;
                    border-radius: 2px;
                }
                i{
                    cursor: pointer;
                    font-size: 14px;
                    color: #fff;
                }
            }
          }
          .App_content_portal{
              width: 100%;
              flex-grow: 1;
              overflow: hidden;
          }
      }
  }
.isH5Open{
    :deep(.webIm_box){
        display: none;
    }
}
  </style>
  